<template>
  <div class="inform">
    <div v-if="!showInsider && !showOtherStaff && !showRelation">
      <NavBar v-if="sourceIsH5" :narBarTitle="isReviewed ? $t('申请会议') : $t('创建会议')" />
      <div class="metting-association" @click="showRelation = true">
        <div class="metting-association-right">
          <div class="metting-association-title">
            <div class="metting-association-titel-big">
              {{ $t('会议关联') }}
            </div>
            <div class="metting-association-titel-small">
              {{ $t('（可快速导入会议数据）') }}
            </div>
          </div>
          <img src="@/assets/images/blueArrow.png" alt="" />
        </div>
        <div class="metting-association-name">
          {{
            relationMeeting.appointmentTopic
              ? relationMeeting.appointmentTopic
              : $t('无')
          }}
        </div>
      </div>
      <div class="metting-theme">
        <div class="metting-theme-title">
          <div class="metting-theme-icon">*</div>
          <div class="metting-theme-name">{{ $t('会议主题') }}</div>
        </div>
        <van-field v-model="meetingTheme" type="textarea" :placeholder="$t('会议主题(50字以内)')" clearable center rows="1"
          maxlength="50" class="theme" autosize @focus="removeRequired" @blur="hasRequired" />
      </div>
      <div class="areaMeeting" @click="areaShow = true" v-show="!ifOnline">
        <img class="location" src="@/assets/images/location.png" alt="" />
        <div class="areaName">{{ meetingRoomName }}</div>
        <!-- <img class="pullMore" src="@/assets/images/pull.png" alt="" /> -->
        <div class="areaText" v-if="multipleRooms && !isReviewed">
          {{ $t('继续添加') }}
        </div>
        <img class="pullMore" src="@/assets/images/blueArrow.png" alt="" />
      </div>
      <div class="encryption" v-if="
        isVideoconferencing == 1 ||
        isVideoconferencing == 2 ||
        isVideoconferencing == 3
      ">
        <div class="encryption-text">
          {{
            isVideoconferencing == '3'
              ? $t('钉钉视频会议')
              : isVideoconferencing == '1'
                ? $t('腾讯会议')
                : $t('企微视频会议')
          }}
        </div>
        <van-switch size="22px" v-model="isShowVideo" />
      </div>
      <div class="encryption" v-show="!ifOnline">
        <div class="encryption-text">{{ $t('加密会议') }}</div>
        <van-switch size="22px" v-model="encryption" />
      </div>
      <van-calendar v-model:show="dateShow" @confirm="dateConfirm" color="#1989fa" :default-date="defaultDate" />
      <div class="informTime">
        <div class="informTime-top">
          <div class="date-box" @click="onDate">
            <div>{{ date }}</div>
          </div>
          <img src="@/assets/images/path.png" alt="" />
          <div class="date-box" @click="choseTime">
            <div>{{ startTime + '-' + endTime }}</div>
          </div>
          <div class="totalTime">
            {{ $t('共') }}
            <div class="allTime">{{ totalTime }}</div>
            {{ $t('分钟') }}
          </div>
        </div>
        <div class="informTime-bottom">
          <img src="@/assets/images/bell.png" alt="" />
          <span>{{ $t('会议开始前') }}{{ preMeetingReminderTime
            }}{{ $t('分钟提醒') }}</span>
        </div>
      </div>
      <div class="replaceStaffBox">
        <div class="replaceStaffBox-top">
          <!-- <img src="@/assets/images/behalfOfOthers.png" alt="" class="pep" /> -->
          <div class="replaceStaffBox-text">{{ $t('预定人') }}</div>
          <div class="replaceStaffBox-staff" @click="showOtherStaff = replaceStaffChecked ? true : showOtherStaff">
            {{
              !replaceStaffChecked
                ? user.name
                : otherStaffData.length
                  ? otherStaffData[0].name
                  : $t('请选择')
            }}
          </div>
          <img v-if="replaceStaffChecked" src="@/assets/images/blueArrow.png" @click="showOtherStaff = true" />
        </div>
        <div class="replaceStaffBox-bottom" v-if="!isReviewed">
          <div class="replaceStaffBox-bottom-text">{{ $t('代发起人') }}</div>
          <van-switch size="22px" v-model="replaceStaffChecked" @change="onReplaceStaffChange"/>
        </div>
      </div>
      <div class="content">
        <div class="content-top">{{ $t('会议议程：') }}</div>
        <van-field v-model="meetingContent" type="textarea" :placeholder="$t('请输入会议内容')" class="content-bottom"
          autosize />
      </div>
      <div class="confereeBox">
        <div class="confereeBox-top">
          <!-- <img src="@/assets/images/adduser.png" alt="" /> -->
          <div class="text">{{ $t('添加内部参会人') }}</div>
          <img src="@/assets/images/add.png" alt="" @click="showInsider = true" />
        </div>
        <div class="confereeBox-bottom" v-show="insiderList.length > 0">
          <InsiderBox
            v-for="(value, idx) in displayDepartmentList"
            :key="value.departmentId"
            :insiderName="value.departmentName"
            @click="delDepartment"
            :idx="idx"
            bColor="1"
            :id="value.departmentId"
            :repeat="value.repeat ? true : false"
          />
          <InsiderBox
            v-for="(value, idx) in displayStaffList"
            :key="value.id"
            :insiderName="value.name"
            @click="delInsiderList"
            bColor="2"
            :idx="idx"
            :id="value.id"
            :repeat="value.repeat ? true : false"
            :showClick="replaceStaffChecked ? (!otherStaffData.length || otherStaffData[0].id != value.id) : value.id != user.id"
          />
        </div>
      </div>
      <div class="confereeBox" v-show="!ifOnline">
        <div class="confereeBox-top">
          <!-- <img src="@/assets/images/adduser.png" alt="" /> -->
          <div class="text">{{ $t('添加外部参会人') }}</div>
          <img src="@/assets/images/add.png" alt="" @click="showOutsider = true" />
        </div>
        <div class="outsiderWrap" v-show="outsiderList.length > 0">
          <div class="outsiderBox" v-for="(item, idx) in outsiderList" :key="item.email">
            <div class="outsiderMsg">
              <div class="outsiderName">{{ item.name }}</div>
              <div class="outsiderEMail">
                {{ item.mobile ? item.mobile : item.email }}
              </div>
              <!-- <div class="outsiderEMail">{{ item.email }}</div> -->
            </div>
            <div class="outsiderDel">
              <img src="@/assets/images/del.png" alt="" @click="delOutsiderList(idx)" />
            </div>
          </div>
        </div>
      </div>
      <div class="metting-summary">
        <div class="text">{{ $t('会议纪要人') }}</div>
        <div class="metting-summary-left" @click="showSummaryStaff = true">
          <div class="meeting-summary-name">{{ summaryName }}</div>
          <img src="@/assets/images/blueArrow.png" alt="" @click="showSummaryStaff = true" />
        </div>
      </div>
      <!-- <div v-if="isReviewed" class="metting-phone">
        <div class="phoneLine">
          <div class="phoneIcon">*</div>
          <div class="phoneText">{{ $t('手机号:') }}</div>
        </div>
        <input type="text" :placeholder="$t('请输入')" v-model="meetingStaffMobile" class="phone-input" />
      </div> -->
      <div class="metting-level">
        <div class="levelText">{{ $t('会议等级:') }}</div>
        <!-- <van-field name="radio">
          <template #input> -->
        <van-radio-group v-model="meetingLevel" direction="horizontal">
          <van-radio :name="0">{{ $t('无') }}</van-radio>
          <van-radio :name="1">{{ $t('1星') }}</van-radio>
          <van-radio :name="2">{{ $t('2星') }}</van-radio>
          <van-radio :name="3">{{ $t('3星') }}</van-radio>
        </van-radio-group>
        <!-- </template>
        </van-field> -->
      </div>
      <div class="metting-service" v-if="isHasService">
        <div class="serviceText">{{ $t('会务服务：') }}</div>
        <!-- <van-field name="radio">
          <template #input> -->
        <van-switch size="22px" v-model="openMeetingService" />
        <!-- </template>
        </van-field> -->
      </div>
      <div class="metting-service" @click="showDept = true" v-if="isChoseDep">
        <div class="popupOk">
          <div class="serviceText">{{ $t('审批流程：') }}</div>
          <div class="okTextStyle">{{ deptName }}</div>
        </div>
        <img src="@/assets/images/dropdown.png" alt="" class="dropdownImg" />
      </div>
      <div class="repeat-box" v-show="ifRepeat">
        <div class="repeatBox-top">
          <div class="repeat-text">
            {{ $t('提示：以下参会人存在参会时间重叠，请提前和参会人确认') }}
          </div>
        </div>
        <div class="repeat-info-wrap">
          <div v-for="item in repeatList" :key="item.userId">
            <div class="repeat-info">
              <div class="repeat-name">{{ item.userName }}</div>
              <div class="repeat-content">
                <div v-for="(childItem, idx) in item.dateOverlaps" :key="idx">
                  <div>
                    {{ dayjs(childItem.beginTime).format('HH:mm') }}-{{
                      dayjs(childItem.endTime).format('HH:mm')
                    }}{{ $t('参与其他会议，重叠时间') }}{{ childItem.time
                    }}{{ $t('分钟') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <van-button round block type="info" native-type="submit" class="confrim-btn" @click="checkMeeting"
        :disabled="isConfirm">{{ $t('确定') }}</van-button>
      <!-- <van-action-sheet
        v-model="areaShow"
        :actions="areaNameList"
        title="选择地区"
        @select="onAreaConfirm"
      /> -->
      <van-popup v-model="areaShow" position="bottom" safe-area-inset-bottom>
        <div>
          <div class="timeListTitle">{{ $t('选择会议室') }}</div>
          <van-checkbox-group v-model="areaResult" class="timeList" :max="roomsNumber">
            <div style="position: absolute; top: 0; height: 318px">
              <van-checkbox :name="index" class="timeListCard" icon-size="21px" v-for="(item, index) in areaNameList"
                :key="index" @click="clickArea(index)">
                <div class="timeListRange">{{ item.name }}</div>
              </van-checkbox>
            </div>
          </van-checkbox-group>
        </div>
        <div class="bookBox">
          <van-button round block type="info" native-type="submit" class="book-btn" @click="toMeetingInform">{{ $t('确定')
          }}</van-button>
        </div>
      </van-popup>
      <van-popup v-model="showSummaryStaff" position="bottom" safe-area-inset-bottom>
        <div>
          <div class="timeListTitle">{{ $t('选择会议纪要人') }}</div>
          <div v-if="!summaryList || !summaryList.length" class="noSummary">
            {{ $t('请先添加内部参会人') }}
          </div>
          <van-checkbox v-model="allCheck" @click="checkAll()" class="timeListAll">{{ $t('所有人') }}</van-checkbox>
          <van-checkbox-group v-model="summaryResult" class="timeList" v-if="summaryList && summaryList.length"
            ref="checkboxGroup">
            <div style="position: absolute; top: 0; height: 318px">
              <van-checkbox :name="index" class="timeListCard" icon-size="21px" v-for="(item, index) in summaryList"
                :key="index" @click="clickSummary(index, item)">
                <div class="timeListRange">{{ item.name }}</div>
              </van-checkbox>
            </div>
          </van-checkbox-group>
        </div>
        <div class="bookBox">
          <van-button round block type="info" native-type="submit" class="book-btn" @click="toSummaryInform">{{ $t('确定')
          }}</van-button>
        </div>
      </van-popup>
      <van-dialog v-model="showOutsider" show-cancel-button confirmButtonColor="#009BFF" cancelButtonColor="#009BFF"
        @confirm="confirmOutsider" class="outsiderStyle" :cancelButtonText="$t('暂不')" :confirmButtonText="$t('确定')">
        <template #title>
          <div class="outsider-title">{{ $t('添加外部参会人员') }}</div>
        </template>
        <van-form class="hasBorder">
          <van-field :label="$t('姓名')" name="username">
            <template #input>
              <input type="text" :placeholder="$t('请输入姓名')" v-model="outsiderName" class="outsider-input" />
            </template>
          </van-field>
          <van-field name="radio" :label="$t('选择')">
            <template #input>
              <van-radio-group v-model="showMobile" direction="horizontal">
                <!-- <van-radio name="1" checked>手机号</van-radio> -->
                <van-radio name="2">{{ $t('邮箱') }}</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <!-- mobileTest -->
          <!-- <van-field v-if="showMobile==1" v-model="visitorMobile" label="手机：" class="space" placeholder="请输入"
              clearable :rules="[{ validator: mobileTest }]" required /> -->

          <!-- <van-field
            v-if="showMobile == 1"
            label="手机"
            :rules="[{ validator: mobileTest }]"
            name="eMobile"
          >
            <template #input>
              <input
                type="text"
                placeholder="请输入手机号"
                v-model="visitorMobile"
                class="outsider-input"
              />
            </template>
          </van-field> -->

          <van-field v-if="showMobile == 2" :label="$t('邮箱')" :rules="[{ validator: emailTest }]" name="eMail">
            <template #input>
              <input type="text" :placeholder="$t('请输入邮箱')" v-model="outsiderEmail" class="outsider-input" />
            </template>
          </van-field>
        </van-form>
      </van-dialog>
      <van-popup v-model="showStatus" position="bottom" safe-area-inset-bottom>
        <div>
          <!-- undo -->
          <van-checkbox-group v-model="result" class="timeList">
            <div style="position: absolute; top: 0; height: 113.07vw">
              <van-checkbox :name="idx" class="timeListCard" icon-size="21px" :disabled="ifFree(item.status, item.endTime) ||
                (isReviewed && item.current)
                " v-for="(item, idx) in validMeetingTimeRange" :key="idx + 10000" @click="clickTime(idx)">
                <div class="timeListRange">
                  {{ item.startTime }}~{{ item.endTime }}
                  <span v-if="item.extra">{{ item.extra }}</span>
                  <span v-else-if="item.conflict" style="color: #999">{{
                    $t('该时间已参加其他会议')
                  }}</span>
                  <span v-else-if="item.current" style="color: #009bff">{{
                    $t('当前时段')
                  }}</span>
                </div>
              </van-checkbox>
            </div>
          </van-checkbox-group>
        </div>
        <div class="bookBox">
          <van-button round block type="info" native-type="submit" class="book-btn" @click="confirmTime">{{ $t('确定')
          }}</van-button>
        </div>
      </van-popup>
      <van-dialog v-model="showConfirm" show-cancel-button confirmButtonColor="#009BFF" cancelButtonColor="#009BFF"
        @confirm="confirmMeeting" class="outsiderStyle" :cancelButtonText="$t('否')" :confirmButtonText="$t('是')">
        <template #title>
          <div class="confirm-title">{{ $t('提示') }}</div>
        </template>
        <div v-if="ifRepeat" :style="{ display: 'flex', justifyContent: 'center' }">
          <div class="confirm-content-repeat">{{ confirmText }}</div>
        </div>
        <div class="confirm-content" v-else>
          {{ isReviewed ? $t('是否确认申请') : $t('是否确认创建')
          }}<span :style="{ color: '#009CFF' }">{{ confirmText }}</span>{{ $t('的会议？') }}
        </div>
      </van-dialog>
      <van-popup v-model="showDept" position="bottom" safe-area-inset-bottom>
        <div>
          <div class="timeListTitle">{{ $t('选择部门') }}</div>
          <van-checkbox-group v-model="allDeptResult" class="timeList" max="1">
            <div style="position: absolute; top: 0; height: 318px">
              <van-checkbox :name="index" class="timeListCard" icon-size="21px" v-for="(item, index) in allDeptList"
                :key="index">
                <div class="timeListRange">{{ item.name }}</div>
              </van-checkbox>
            </div>
          </van-checkbox-group>
        </div>
        <div class="bookBox">
          <van-button round block type="info" native-type="submit" class="book-btn" @click="toDeptInform">{{ $t('确定')
          }}</van-button>
        </div>
      </van-popup>
    </div>
    <Address
      :userList="userList"
      v-else-if="showInsider && !showOtherStaff && !showRelation"
      @back="toInform"
      @confirm="confirmSearch"
      :selectedList="insiderList"
      :proxyPerson="otherStaffData && otherStaffData[0]"
    />
    <OtherStaff
      :userList="withoutSelfList"
      v-else-if="!showInsider && showOtherStaff && !showRelation"
      @back="toInform"
      @confirm="confirmOtherStaff"
      :selectedList="otherStaffData"
    />
    <Relation
      v-else-if="!showInsider && !showOtherStaff && showRelation"
      @back="toInform"
      @confirm="confirmRelation"
      :selectedList="relationMettingList"
    />
  </div>
</template>
<script>
import dayjs from 'dayjs'
import {
  getUserList,
  getMeetingRoomConfig,
  getMeetingRoomByArea,
  queryAppointmentList,
  bookAppointment,
  appointmentOnline,
  dateOverlap,
  getAppointmentByID,
  getStaffById,
  getstaffByDepartment,
  queryMeetingDevice,
  getHoliday,
  getMeetingRoomById,
  getStaffDepartment,
  addTodo,
} from '@/services/api'
import InsiderBox from '@/components/insiderBox'
import NavBar from '@/components/navBar'
import Address from './address.vue'
import OtherStaff from './otherStaff.vue'
import Relation from './relation.vue'
import Vue from 'vue'
import {
  Calendar,
  Popup,
  Button,
  Toast,
  Field,
  Dialog,
  Checkbox,
  CheckboxGroup,
  ActionSheet,
  Switch,
  RadioGroup,
  Radio,
} from 'vant'
Vue.use(Calendar)
Vue.use(Popup)
Vue.use(Button)
Vue.use(Toast)
Vue.use(Field)
Vue.use(Dialog)
Vue.use(Checkbox)
Vue.use(ActionSheet)
Vue.use(CheckboxGroup)
Vue.use(Switch)
Vue.use(RadioGroup)
Vue.use(Radio)
export default {
  name: 'Inform',
  components: {
    NavBar,
    InsiderBox,
    Address,
    OtherStaff,
    Relation,
  },
  data() {
    return {
      isRequired: true,
      showSelect: false,
      user: {},
      showRelation: false,
      relationMeeting: {},
      relationMettingList: {},
      relationData: {},
      summaryName: '',
      summaryPeopleId: '',
      allCheck: false,
      summaryList: [],
      summaryResult: [],
      meetingRoomName: '',
      meetingRoomId: [],
      areaShow: false,
      areaList: [],
      areaNameList: [],
      userList: [],
      searchList: [],
      meetingStatusList: [],
      originList: [],
      result: [],
      areaResult: [],
      timeUnit: [],
      startTime: '',
      nowDate: '',
      endTime: '',
      date: '',
      parameterDate: '',
      searchName: '',
      meetingTheme: '',
      meetingContent: '',
      showInsider: false,
      showOutsider: false,
      showSeachList: false,
      showStatus: false,
      showSummaryStaff: false,
      insiderList: [],
      rangeNum: '',
      insiderTmpList: [],
      outsiderName: '',
      visitorMobile: '', //外部参会人手机号
      showMobile: '2', //true默认展示手机，false展示邮箱
      outsiderEmail: '',
      outsiderList: [],
      scheduledMaxTime: null,
      totalInfo: [],
      sourceIsH5: true,
      replaceStaffChecked: false,
      encryption: false,
      isShowVideo: false,
      isVideoconferencing: 0,
      showOtherStaff: false,
      otherStaffData: [],
      isConfirm: false,
      withoutSelfList: [],
      displayDepartmentList: [],
      displayStaffList: [],
      ifOnline: false,
      ifRepeat: false,
      showConfirm: false,
      confirmText: '',
      repeatList: [],
      preMeetingReminderTime: null,
      devicesAIO: {},
      dateShow: false,
      defaultDate: '',
      isDate: '',
      selfSchedule: [],
      multipleRooms: true,
      roomsNumber: 0,
      isReviewed: false,
      meetingLevel: 0,
      showDept: false,
      allDeptResult: [],
      allDeptList: [],
      deptName: '',
      precessDepartmentId: '',
      openMeetingService: false,
      isHasService: false,
      meetingStaffMobile: '',
      processConfigId: '',
      meetingManger: '',
    }
  },

  methods: {
    handleFocus() {
      setTimeout(() => {
        this.$refs.myInput.scrollIntoView({ 
          behavior: 'smooth',
          block: 'center'
        });
      }, 300); // 延迟确保键盘已弹出
    },
    getALLInfo(roomId, userId, isChoseDep, ifOnline) {
      if (roomId && !ifOnline) {
        getMeetingRoomById(roomId).then((res) => {
          if (res.openMeetingService && res.meetingManger) {
            this.isHasService = true
            this.meetingManger = res.meetingManger
          } else {
            this.isHasService = false
            this.meetingManger = ''
          }
        })
      }
      if (roomId && !ifOnline && isChoseDep) {
        getStaffDepartment({ staffId: userId }).then((res) => {
          this.allDeptList = res
          if (res && res.length) {
            this.deptName = res[0].name
            this.precessDepartmentId = res[0].id
          }
        })
      }
    },
    onAreaConfirm(v, idx) {
      this.meetingRoomName = v.name
      this.meetingRoomId = [this.areaList[idx].id]
      this.getAppointmentList(
        this.user.companyId,
        this.parameterDate,
        this.meetingRoomId[0]
      )
      this.areaShow = false
    },
    clickArea(index) {
      if (this.areaResult.length < 2) return
      if (!this.areaResult.some((num) => num == index)) return
    },
    checkAll() {
      if (this.allCheck) {
        this.$refs.checkboxGroup.toggleAll(true)
      } else {
        this.$refs.checkboxGroup.toggleAll()
      }
    },
    clickSummary(index) {
      if (this.summaryResult.length == this.summaryList.length) {
        this.allCheck = true
      } else {
        this.allCheck = false
      }
      if (this.summaryResult.length < 2) return
      if (!this.summaryResult.some((num) => num == index)) return
    },
    toSummaryInform() {
      if (!this.summaryList || !this.summaryList.length) {
        this.showSummaryStaff = false
        return
      }
      if (this.summaryResult.length == 0) {
        Toast.fail(this.$t('会议纪要人不能为空'))
        return
      }
      this.summaryResult.sort(function (a, b) {
        return a - b
      })
      let newName = ''
      let newIds = []
      if (this.summaryResult.length == this.summaryList.length) {
        newName = this.$t('所有人')
      } else if (this.summaryResult.length > 1) {
        newName =
          this.summaryList[this.summaryResult[0]].name +
          this.$t('等') +
          this.summaryResult.length +
          this.$t('人')
      } else {
        newName = this.summaryList[this.summaryResult[0]].name
      }
      this.summaryResult.map((item, index) => {
        newIds.push(this.summaryList[item].id)
      })
      this.summaryName = newName
      this.summaryPeopleId = newIds.join(',')
      this.showSummaryStaff = false
    },
    toMeetingInform() {
      if (this.areaResult.length == 0) {
        Toast.fail(this.$t('预约会议室不能为空'))
        return
      }
      this.areaResult.sort(function (a, b) {
        return a - b
      })
      let newName = ''
      let newIds = []
      this.areaResult.map((item, index) => {
        if (index < this.areaResult.length - 1) {
          newName += this.areaList[item].name + '、'
        } else {
          newName += this.areaList[item].name
        }
        newIds.push(this.areaList[item].id)
      })
      this.meetingRoomName = newName
      this.meetingRoomId = newIds
      this.getAppointmentList(
        this.user.companyId,
        this.parameterDate,
        this.meetingRoomId[0]
      )
      this.areaShow = false
    },

    toDeptInform() {
      if (this.allDeptResult.length == 0) {
        Toast.fail(this.$t('审批部门不能为空'))
        return
      }
      let index = this.allDeptResult[0]
      this.deptName = this.allDeptList[index].name
      this.precessDepartmentId = this.allDeptList[index].id
      this.showDept = false
    },

    async getUsers(companyId) {
      try {
        const res = await getUserList({ companyId })
        let arr = [...res]
        this.userList = arr
        this.withoutSelfList = this.userList.filter((item) => {
          return item.id != this.user.id
        })
        let tmp = this.userList.filter((item) => {
          return item.id == this.user.id
        })
        this.insiderList = tmp // 把自己加到参会人里面
        this.summaryList = tmp
        this.summaryName =
          this.summaryResult.length > 1
            ? this.summaryList[this.summaryResult[0]].name +
            this.$t('等') +
            this.summaryResult.length +
            this.$t('人')
            : this.summaryList[this.summaryResult[0]].name
        this.displayStaffList = tmp
      } catch (error) {
        console.log(error)
      }
    },
    async checkRepeatt(staffIds) {
      let selectDate = dayjs(this.parameterDate).format('YYYY-MM-DD')
      let beginTime = selectDate + ' ' + this.startTime + ':00'
      let endTime = selectDate + ' ' + this.endTime + ':00'
      const res = await dateOverlap({
        staffIds,
        beginTime,
        endTime,
      })
      if (res.length) {
        res.forEach((item) => {
          item.dateOverlaps.forEach((meetingInfo) => {
            if (
              dayjs(meetingInfo.beginTime).valueOf() >=
              dayjs(beginTime).valueOf() &&
              dayjs(meetingInfo.endTime).valueOf() <= dayjs(endTime).valueOf()
            ) {
              meetingInfo.time =
                (dayjs(meetingInfo.endTime).valueOf() -
                  dayjs(meetingInfo.beginTime).valueOf()) /
                (1000 * 60)
              return
            }
            if (
              dayjs(meetingInfo.beginTime).valueOf() >=
              dayjs(beginTime).valueOf() &&
              dayjs(meetingInfo.endTime).valueOf() >= dayjs(endTime).valueOf()
            ) {
              meetingInfo.time =
                (dayjs(endTime).valueOf() -
                  dayjs(meetingInfo.beginTime).valueOf()) /
                (1000 * 60)
              return
            }
            if (
              dayjs(meetingInfo.beginTime).valueOf() <=
              dayjs(beginTime).valueOf() &&
              dayjs(meetingInfo.endTime).valueOf() <= dayjs(endTime).valueOf()
            ) {
              meetingInfo.time =
                (dayjs(meetingInfo.endTime).valueOf() -
                  dayjs(beginTime).valueOf()) /
                (1000 * 60)
              return
            }
          })
        })
        this.repeatList = res
        this.ifRepeat = true
      } else {
        this.ifRepeat = false
        this.repeatList = []
      }
    },
    onDate() {
      this.defaultDate = new Date(this.parameterDate)
      this.dateShow = true
    },
    dateConfirm(value) {
      this.dateShow = false
      this.date = this.$t('{slot1}月{slot2}日 {slot3}', {
        slot1: value.getMonth() + 1,
        slot2: value.getDate(),
        slot3: this.formatDate(value),
      })
      this.parameterDate = dayjs(value).format('YYYY-MM-DD')
      this.isDate = value
      const nowDate = dayjs().format('YYYY-MM-DD')
      if (!this.ifOnline) {
        this.getAppointmentList(
          this.user.companyId,
          this.parameterDate,
          this.meetingRoomId[0]
        )
      }
      if (
        dayjs(value).isSame(dayjs(), 'day') &&
        dayjs(`${nowDate} ${this.startTime}`).isBefore(
          dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss')
        )
      ) {
        this.result = []
        this.rangeNum = 0
        this.startTime = ''
        this.endTime = ''
        Toast.fail(this.$t('会议时间段不可为无效时间段，请重新选择'))
      } else {
        const startIdx = this.validMeetingTimeRange.findIndex(
          (v) => v.startTime == this.startTime
        )
        const endIdx = this.validMeetingTimeRange.findIndex(
          (v) => v.endTime == this.endTime
        )

        this.result = []
        if (startIdx < 0 || endIdx < 0) return
        // 补全startIdx, endIdx之间的值
        for (let index = startIdx; index <= endIdx; index++) {
          this.result = this.result.concat(index)
        }
        console.log('result', this.result)
      }
    },
    async getInfo() {
      const info = this.relationData
      let nameList = [...info.attendDetails]
      if (info.attach) {
        let filed = JSON.parse(info.attach)
        this.filedList = filed
      }
      if (info.meetingPeopleId.split(',').length > info.attendDetails.length) {
        const { name } = await getStaffById(info.appointmentStaff)
        info.attendDetails.push({
          agree: 'true',
          staffId: info.appointmentStaff,
          staffName: name,
        })
      }
      info.attendDetails.forEach((item) => {
        if (info.appointmentStaff == item.staffId) {
          this.inviteName = item.staffName
        }
      })
      let newIdList = info.meetingPeopleId.split(',')
      let tmp = this.userList.filter((item) => {
        if (info.meetingPeopleId.includes(',')) {
          return newIdList.includes(item.id + '')
        } else {
          return info.meetingPeopleId == item.id
        }
      })
      this.insiderList = tmp // 修改，把当前记录中的参会人加进去
      this.summaryList = tmp
      if (info.summaryUserDetails && info.summaryUserDetails.length) {
        let newIdList = []
        let newResult = []
        info.summaryUserDetails.map((peopel) => {
          this.summaryList.map((item, index) => {
            if (peopel.staffId == item.id) {
              newIdList.push(item.id)
              newResult.push(index)
            }
          })
        })
        this.summaryResult = newResult
        this.summaryPeopleId = newIdList.join(',')
        this.summaryName =
          this.summaryList.length == info.summaryUserDetails.length
            ? this.$t('所有人')
            : info.summaryUserDetails.length == 1
              ? info.summaryUserDetails[0].staffName
              : info.summaryUserDetails[0].staffName +
              this.$t('等') +
              newResult.length +
              this.$t('人')
      }
      let idList = nameList.map((item) => item.staffId)
      let arr = this.userList.filter((item) => idList.includes(item.id))
      this.getDepartment(this.user.companyId, arr)
    },
    async getDepartment(companyId, list) {
      const res = await getstaffByDepartment({ companyId })
      this.totalInfo = res
      this.checkDepartment(list)
    },
    async confirmRelation(data) {
      if (data) {
        this.relationMeeting = data
        this.relationMettingList = data
        let appointmentId = data.id
        try {
          await Dialog.confirm({
            message: this.$t('是否要导入会议数据！'),
            messageAlign: 'center',
            cancelButtonText: this.$t('取消'),
            confirmButtonText: this.$t('确定'),
            confirmButtonColor: '#009BFF',
            cancelButtonColor: '#009BFF',
            allowHtml: true,
          })
          const info = await getAppointmentByID({ appointmentId })
          this.relationData = info
          this.meetingTheme = info.appointmentTopic
          this.meetingContent = info.meetingRecord
          this.getInfo()
          if (info.otherPeopleRecord) {
            let userOutSideList = []
            JSON.parse(info.otherPeopleRecord).forEach((item) =>
              userOutSideList.push(item)
            )
            this.outsiderList = [...userOutSideList]
          }
        } catch (err) {
          console.log(err)
        }
      }
      this.showRelation = false
    },
    confirmSearch(data, displayData, total) {
      let arr = []
      const uniqueData = []
      const uniqueDisplayStaffList = []
      const idSet = new Set()
      data.forEach((info) => {
        if (!idSet.has(info.id)) {
          idSet.add(info.id)
          uniqueData.push(info)
        }
      })
      if (data.length) {
        data.forEach((info) => arr.push(info.id))
        if (this.replaceStaffChecked && this.otherStaffData.length) {
          arr.push(this.otherStaffData[0].id)
        }
        this.checkRepeatt(arr.join(','))
      } else this.ifRepeat = false
      this.insiderList = [...uniqueData]
      this.summaryList = [...uniqueData]
      if (this.summaryResult.length) {
        this.summaryName =
          this.summaryResult.length > 1
            ? this.summaryList[this.summaryResult[0]].name +
            this.$t('等') +
            this.summaryResult.length +
            this.$t('人')
            : this.summaryList[this.summaryResult[0]].name
      }
      this.displayDepartmentList = displayData.department
      const displayStaffIdSet = new Set()
      displayData.staff.forEach((staff) => {
        if (!displayStaffIdSet.has(staff.id)) {
          uniqueDisplayStaffList.push(staff)
        }
      })
      this.displayStaffList = uniqueDisplayStaffList
      this.totalInfo = total
      this.showInsider = false
    },
    onReplaceStaffChange(opened) {
      console.log('Switch 状态改变为:', opened);
      if (!opened) {
        // 关闭代发起时
        this.otherStaffData = []
        const currentUser = this.userList.find((item) => {
          return item.id == this.user.id
        })
        this.handleProxyPersonChange(currentUser)
      }
    },
    confirmOtherStaff(data) {
      this.otherStaffData = [...data]
      if (data && data.length) {
        this.handleProxyPersonChange(data[0])
      }
      let arr = []
      if (data.length) {
        this.insiderList.length &&
          this.insiderList.forEach((info) => arr.push(info.id))
        arr.push(data[0].id)
        this.checkRepeatt(arr.join(','))
      }
      this.showOtherStaff = false
    },
    handleProxyPersonChange(proxyPerson) {
      let newInsiderList = [proxyPerson, ...this.insiderList]
      newInsiderList = newInsiderList.reduce((acc, current) => {
        if (!acc.find(item => item.id === current.id)) {
          acc.push(current);
        }
        return acc;
      }, []);
      this.insiderList = newInsiderList
      this.summaryList = newInsiderList
      this.displayStaffList = newInsiderList

      // 重新计算会议纪要人数据
      const summaryPeopleList = this.summaryPeopleId.split(',')
      const newResult = new Set()
      const newIdList = new Set()
      if (summaryPeopleList && summaryPeopleList.length) {
        summaryPeopleList.forEach((peopel) => {
          this.summaryList.forEach((item, index) => {
            if (peopel == item.id) {
              newIdList.add(item.id)
              newResult.add(index)
            }
          })
        })
        newIdList.add(proxyPerson.id)
        newResult.add(0)
        this.summaryResult = [...newResult]
        this.summaryPeopleId = [...newIdList].join(',')
        if (this.summaryResult.length) {
          this.summaryName =
            this.summaryResult.length > 1
              ? this.summaryList[this.summaryResult[0]].name +
              this.$t('等') +
              this.summaryResult.length +
              this.$t('人')
              : this.summaryList[this.summaryResult[0]].name
        }
      }
    },
    delStaffIdList(id) {
      this.insiderList = this.insiderList.filter((item) => item.id != id)
      console.log(this.insiderList, 'delStaffIdList--tmptmp')

      this.summaryList = this.insiderList
      if (this.summaryList.length == 0) {
        this.summaryName = this.$t('无')
        this.summaryPeopleId = ''
        this.summaryResult = []
      } else {
        let summaryPeopleList = this.summaryPeopleId.split(',')
        let newResult = []
        let newIdList = []
        if (summaryPeopleList && summaryPeopleList.length) {
          summaryPeopleList.map((peopel) => {
            this.summaryList.map((item, index) => {
              if (peopel == item.id) {
                newIdList.push(item.id)
                newResult.push(index)
              }
            })
          })
          this.summaryResult = newResult
          this.summaryPeopleId = newIdList.join(',')
          if (this.summaryResult.length) {
            this.summaryName =
              this.summaryList == newResult.length
                ? this.$t('所有人')
                : newResult.length == 1
                  ? this.summaryList[newResult[0]].name
                  : this.summaryList[newResult[0]].name +
                  this.$t('等') +
                  newResult.length +
                  this.$t('人')
          }
        }
      }
    },
    delInsiderList(id, idx) {
      this.insiderList = this.insiderList.filter((item) => item.id != id)
      console.log(this.insiderList, 'insiderList')
      this.summaryList = this.insiderList
      if (this.summaryList.length == 0) {
        this.summaryName = this.$t('无')
        this.summaryPeopleId = ''
        this.summaryResult = []
      } else {
        let summaryPeopleList = this.summaryPeopleId.split(',')
        let newResult = []
        let newIdList = []
        if (summaryPeopleList && summaryPeopleList.length) {
           // 删除内部参会人后，同步从会议纪要人中过滤掉删除的人
          summaryPeopleList.map((peopel) => {
            this.summaryList.map((item, index) => {
              if (peopel == item.id) {
                newIdList.push(item.id)
                newResult.push(index)
              }
            })
          })
          this.summaryResult = newResult
          this.summaryPeopleId = newIdList.join(',')
          if (!newResult.length) {
            this.summaryName = this.$t('无')
            this.summaryPeopleId = ''
            this.summaryResult = []
          } else {
            this.summaryName =
              this.summaryList.length == newResult.length
                ? this.$t('所有人')
                : newResult.length == 1
                  ? this.summaryList[newResult[0]].name
                  : this.summaryList[newResult[0]].name +
                  this.$t('等') +
                  newResult.length +
                  this.$t('人')
          }
        }
      }
      this.displayStaffList.splice(idx, 1)
      if (this.insiderList.length) {
        let arr = []
        this.insiderList.forEach((info) => arr.push(info.id))
        if (this.replaceStaffChecked && this.otherStaffData.length) {
          arr.push(this.otherStaffData[0].id)
        }
        this.checkRepeatt(arr.join(','))
      } else this.ifRepeat = false
    },
    delDepartment(id, idx) {
      this.AllDelete(this.totalInfo, id)
      this.displayDepartmentList.splice(idx, 1)
      if (this.displayDepartmentList.length > 0) {
        this.checkDepartment(this.insiderList)
      }
      if (this.insiderList.length) {
        let arr = []
        this.insiderList.forEach((info) => arr.push(info.id))
        if (this.replaceStaffChecked && this.otherStaffData.length) {
          arr.push(this.otherStaffData[0].id)
        }
        this.checkRepeatt(arr.join(','))
      } else this.ifRepeat = false
    },
    AllDelete(data, id) {
      data.forEach((item) => {
        if (id) {
          if (item.departmentId == id) {
            if (item.staffs && item.staffs.length > 0) {
              item.staffs.forEach((staffItem) =>
                this.delStaffIdList(staffItem.staffId)
              )
            }
            if (item.children.length > 0) {
              this.AllDelete(item.children)
            } else return
          } else {
            if (item.children.length > 0) {
              this.AllDelete(item.children, id)
            } else return
          }
        } else {
          if (item.staffs && item.staffs.length > 0) {
            item.staffs.forEach((staffItem) =>
              this.delStaffIdList(staffItem.staffId)
            )
          }
          if (item.children.length > 0) {
            this.AllDelete(item.children)
          } else return
        }
      })
    },
    checkDepartment(data) {
      let arr = []
      data.forEach((item) => {
        if (item.departmentId.includes(',')) {
          let departmentIdList = item.departmentId.split(',')
          departmentIdList.forEach((id) => arr.push(id))
        } else arr.push(item.departmentId)
      })
      arr = Array.from(new Set(arr))
      let selectedIdList = data.map((item) => item.id)
      let department = []
      let includeDepartment = []
      arr.forEach((departmentId) => {
        let slectedNum = data.filter((item) => {
          if (item.departmentId.includes(',')) {
            let departmentIdList = item.departmentId.split(',')
            return departmentIdList.includes(departmentId)
          } else return item.departmentId == departmentId
        }).length
        let departmentInfo = this.checkTotalStaffCount(
          this.totalInfo,
          departmentId
        )
        if (
          departmentInfo.staffs &&
          slectedNum == departmentInfo.staffs.length
        ) {
          //判断是否最底层部门
          if (departmentInfo.children.length == 0) {
            let finalDepartment = this.checkSuperiorDepartment(
              departmentInfo,
              departmentId,
              arr
            )
            finalDepartment &&
              department.every(
                (item) => item.departmentId != finalDepartment.departmentId
              ) &&
              department.push(finalDepartment)
          } else {
            let ifAllChildSelected = []
            departmentInfo.children.forEach((childItem) => {
              let bl = this.checkSubordinateDepartment(
                childItem,
                selectedIdList
              )
              ifAllChildSelected.push(bl)
            })
            if (ifAllChildSelected.every((item) => item == true)) {
              let finalDepartment = this.checkSuperiorDepartment(
                departmentInfo,
                departmentId,
                arr
              )
              if (
                finalDepartment &&
                department.every(
                  (item) => item.departmentId != finalDepartment.departmentId
                )
              ) {
                department.push(finalDepartment)
                this.handlerFinalDepartment(finalDepartment, includeDepartment)
              }
            } else return
          }
        }
      })
      includeDepartment = Array.from(new Set(includeDepartment))
      department = department.filter((item) => {
        if (item.pid) {
          return (
            !includeDepartment.includes(item.pid) &&
            !includeDepartment.includes(item.departmentId)
          )
        } else return true
      })
      // this.displayDepartmentList = [...department]
      // let staffInDepartment = []
      // staffInDepartment = this.fliterDepartment(department, staffInDepartment)
      // this.displayStaffList = this.insiderList.filter(item => !staffInDepartment.includes(item.id))
      this.displayDepartmentList = []
      this.displayStaffList = this.insiderList
    },
    fliterDepartment(data, arr) {
      data.forEach((item) => {
        item.staffs &&
          item.staffs.length > 0 &&
          item.staffs.forEach((staffItem) => arr.push(staffItem.staffId))
        item.children.length > 0 && this.fliterDepartment(item.children, arr)
      })
      return arr
    },
    //上级部门查询
    checkSuperiorDepartment(data, departmentId, arr) {
      let response = null
      if (data.pid) {
        let pidDepartmentInfo = this.checkTotalStaffCount(
          this.totalInfo,
          data.pid
        )
        let slectedNum = this.insiderList.filter(
          (item) => item.departmentId == pidDepartmentInfo.departmentId
        ).length
        if (
          slectedNum + data.totalStaffCount ==
          pidDepartmentInfo.totalStaffCount
        ) {
          let childData = pidDepartmentInfo.children.filter(
            (item) => item.departmentId == departmentId
          )[0]
          response = this.checkSuperiorDepartment(
            pidDepartmentInfo,
            pidDepartmentInfo.departmentId,
            arr,
            childData
          )
        } else {
          response = data
          return response
        }
      } else {
        response = data
        return response
      }
      return response
    },
    //下级部门查询
    checkSubordinateDepartment(data, selectedIdList) {
      let bl = true
      if (data.staffs && data.staffs.length > 0) {
        bl = data.staffs.every((childStaff) =>
          selectedIdList.includes(childStaff.staffId)
        )
      }
      if (bl && data.children.length > 0) {
        data.children.forEach((item) => {
          bl = this.checkSubordinateDepartment(item, selectedIdList)
        })
      }
      return bl
    },
    handlerFinalDepartment(data, idList) {
      if (data.children.length > 0) {
        data.children.forEach((item) => {
          idList.push(item.departmentId)
          if (item.children.length > 0) {
            this.handlerFinalDepartment(item, idList)
          }
        })
      }
    },
    checkTotalStaffCount(data, id) {
      let selectedData = {}
      data.some((item) => {
        if (item.departmentId == id) {
          selectedData = item
          return true
        } else {
          if (item.children && item.children.length > 0) {
            let returnData = this.checkTotalStaffCount(item.children, id)
            returnData.staffs && (selectedData = returnData)
          } else return
        }
      })
      return selectedData
    },
    delOutsiderList(idx) {
      this.outsiderList.splice(idx, 1)
    },
    removeRequired() {
      this.isRequired = false
    },
    hasRequired() {
      if (this.meetingTheme) {
        this.isRequired = false
      } else {
        this.isRequired = true
      }
    },
    async choseTime() {
      let selectDate = dayjs(this.parameterDate).format('YYYY-MM-DD')
      this.selfSchedule = (
        await dateOverlap({
          staffIds: !this.replaceStaffChecked
            ? this.user.id
            : this.otherStaffData[0].id,
          beginTime: selectDate + ' 00:00:00',
          endTime: selectDate + ' 24:00:00',
        })
      )?.[0]?.dateOverlaps
      let arr = [...this.result]
      arr.sort((a, b) => a - b)
      this.result = arr.filter(
        (num) => this.validMeetingTimeRange[num]?.status === '#FFFFFF'
      )
      this.showStatus = true
    },
    getNowFormatDate(date) {
      let seperator1 = '-'
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      let currentdate = year + seperator1 + month + seperator1 + strDate
      return currentdate
    },
    ifFree(color, date) {
      if (color == '#FFFFFF') {
        return false
      } else {
        return true
      }
    },
    dislodgeZero(str) {
      if (str[0] == '0') {
        return (str = str.substring(1, 2))
      } else {
        return (str = str.substring(0, 2))
      }
    },
    toTime(hour, min) {
      if (hour == 0) {
        hour = '00'
      }
      if (hour < 10 && hour > 0) {
        hour = '0' + hour
      }
      if (min == 60) {
        min = '00'
        hour = hour - 0 + 1
        if (hour < 10) {
          hour = '0' + hour
        }
      }
      if (min < 10) {
        min = '0' + min
      }
      if (min == 0) {
        min = '00'
      }
      return hour + ':' + min
    },
    // 获取会时间
    async getMeetingTimeRange(developerId) {
      try {
        const res = await getMeetingRoomConfig({
          developerId,
        })
        this.preMeetingReminderTime = res?.preMeetingReminderTime
          ? res.preMeetingReminderTime
          : 15
        const newData = {
          signBeforeMinute: res?.signBeforeMinute || 10,
          signAfterMinute: res?.signAfterMinute || 10,
          noSignReleaseTime: res?.noSignReleaseTime || 10,
        }
        this.multipleRooms = res.multiRoomAppoint
        this.roomsNumber = res.multiRoomAppoint && !this.isReviewed ? 0 : 1
        this.devicesAIO = newData
        let timeUnit = 60 / res.timeUnit
        if (this.ifOnline) {
          let onlineTime = []
          for (let i = 0; i <= 24; i++) {
            onlineTime.push(i)
          }
          let onlineLength = 24 * timeUnit
          let onlineConfig = []
          for (let i = 0; i < onlineLength; i++) {
            onlineConfig.push({
              startTime: this.toTime(
                parseInt(i / timeUnit),
                i * res.timeUnit - 60 * parseInt(i / timeUnit)
              ),
              endTime: this.toTime(
                parseInt(i / timeUnit),
                (i + 1) * res.timeUnit - 60 * parseInt(i / timeUnit)
              ),
              status: '#FFFFFF',
            })
          }
          this.originList = onlineConfig
          this.meetingStatusList = JSON.parse(JSON.stringify(this.originList))
        } else {
          if (res.scheduledEndTime == '23:59') {
            res.scheduledEndTime = '24:00'
          }
          let startTime = this.dislodgeZero(res.scheduledStartTime) - 0
          let endTime = this.dislodgeZero(res.scheduledEndTime) - 0

          let length = (endTime - startTime) * timeUnit
          let configArr = []
          for (let i = 0; i < length; i++) {
            configArr.push({
              startTime: this.toTime(
                startTime + parseInt(i / timeUnit),
                i * res.timeUnit - 60 * parseInt(i / timeUnit)
              ),
              endTime: this.toTime(
                startTime + parseInt(i / timeUnit),
                (i + 1) * res.timeUnit - 60 * parseInt(i / timeUnit)
              ),
              status: '#FFFFFF',
              extra: '',
            })
          }
          this.originList = configArr
          this.meetingStatusList = JSON.parse(JSON.stringify(this.originList))
        }
      } catch (error) {
        console.log(error.response.data.message)
      }
    },
    async getMeetingRoomInformation(developerId, areaId) {
      try {
        const res = await getMeetingRoomByArea({
          developerId,
          areaId,
        })
        let tmpArr = [...res]
        tmpArr.forEach((item, idx) => {
          if (item.state === 'nouse') {
            // tmpArr.splice(idx, 1)
          }
        })
        tmpArr.forEach((item) => {
          if (item.state != 'nouse') {
            this.areaNameList.push({ name: item.name })
            this.areaList.push({ name: item.name, id: item.id })
          }
        })
      } catch (error) {
        console.log(error)
      }
    },
    async getAppointmentList(companyId, date, meetingRoomId) {
      try {
        const res = await queryAppointmentList({
          date,
          meetingRoomId,
          companyId,
        })
        let ifAdvanced = false
        this.meetingStatusList = JSON.parse(JSON.stringify(this.originList))
        let nowTime = dayjs().valueOf()
        if (res.length == 0) {
          this.meetingStatusList.forEach((item) => {
            let startTime = dayjs(date + ' ' + item.startTime).valueOf()
            let endTime = dayjs(date + ' ' + item.endTime).valueOf()
            if (
              nowTime >= dayjs(this.nowDate + ' ' + startTime).valueOf() &&
              nowTime <= dayjs(this.nowDate + ' ' + endTime).valueOf()
            ) {
              ; (item.extra = this.$t('当前时段')) &&
                (this.$refs['extra' + idx][0].style.color = '#009BFF')

              item.status = '#FFFFFF'
              item.extra = ''
            }
          })
        } else {
          this.meetingStatusList.forEach((item) => {
            let startTime = dayjs(date + ' ' + item.startTime).valueOf()
            let endTime = dayjs(date + ' ' + item.endTime).valueOf()
            res.forEach((v) => {
              if (v.appointmentStaff == -1) {
                // if (v.state == 'complete') return
                if (
                  (startTime >= dayjs(v.appointmentStartTime).valueOf() &&
                    startTime <= dayjs(v.appointmentEndTime).valueOf()) ||
                  (endTime >= dayjs(v.appointmentStartTime).valueOf() &&
                    endTime <= dayjs(v.appointmentEndTime).valueOf()) ||
                  (dayjs(v.appointmentStartTime).isBetween(
                    dayjs(startTime),
                    dayjs(endTime),
                    'minutes',
                    '[]'
                  ) &&
                    endTime != dayjs(v.appointmentStartTime).valueOf()) ||
                  (dayjs(v.appointmentEndTime).isBetween(
                    dayjs(startTime),
                    dayjs(endTime),
                    'minutes',
                    '[]'
                  ) &&
                    startTime != dayjs(v.appointmentEndTime).valueOf())
                ) {
                  item.status = '#84C144'
                  item.extra = this.$t('已被临时人员预订')
                  if (
                    v.actualEndTime &&
                    dayjs(v.actualEndTime).valueOf() < dayjs(endTime).valueOf()
                  ) {
                    item.extra = ``
                    item.status = '#FFFFFF'
                  }
                  if (endTime <= dayjs().valueOf()) {
                    item.extra = ``
                    item.status = '#FFFFFF'
                  }
                  return
                }
              }
              if (
                v.actualStartTime &&
                v.appointmentStaff !== -1 &&
                ((dayjs(v.actualStartTime).valueOf() >= startTime &&
                  dayjs(v.actualStartTime).valueOf() <= endTime) ||
                  (dayjs(v.actualStartTime).valueOf() <= endTime &&
                    dayjs(v.appointmentStartTime).valueOf() >= endTime))
              ) {
                ifAdvanced = true
              } else {
                ifAdvanced = false
              }
              if (
                ifAdvanced ||
                (startTime >= dayjs(v.appointmentStartTime).valueOf() &&
                  endTime <= dayjs(v.appointmentEndTime).valueOf()) ||
                (dayjs(v.appointmentStartTime).isBetween(
                  dayjs(startTime),
                  dayjs(endTime),
                  'minutes',
                  '[]'
                ) &&
                  endTime != dayjs(v.appointmentStartTime).valueOf()) ||
                (dayjs(v.appointmentEndTime).isBetween(
                  dayjs(startTime),
                  dayjs(endTime),
                  'minutes',
                  '[]'
                ) &&
                  startTime != dayjs(v.appointmentEndTime).valueOf())
              ) {
                item.extra =
                  v.meetingSource == 'PROCESS'
                    ? this.$t('已被{slot1}申请', { slot1: v.staffName })
                    : this.$t('已被{slot1}预订', { slot1: v.staffName })
                item.status = '#F7B500'
                if (v.state == 'cancel') {
                  item.status = '#FFFFFF'
                  item.extra = ''
                }
                if (
                  v.actualEndTime &&
                  dayjs(v.actualEndTime).valueOf() < dayjs(endTime).valueOf()
                ) {
                  item.extra = ``
                  item.status = '#FFFFFF'
                }
              }
            })
          })
        }
        this.getALLInfo(
          meetingRoomId,
          this.user.id,
          this.isChoseDep,
          this.ifOnline
        )
      } catch (error) {
        console.log(error)
      }
    },
    confirmTime() {
      if (this.result.length == 0) {
        Toast.fail(this.$t('预约时间段不能为空'))
        return
      }
      this.result.sort(function (a, b) {
        return a - b
      })
      let continuous = this.result.every((val, idx) => {
        if (idx == this.result.length - 1) {
          return true
        } else {
          return this.result[idx + 1] - val == 1
        }
      })
      if (continuous) {
        this.startTime = this.validMeetingTimeRange[this.result[0]].startTime
        this.endTime =
          this.validMeetingTimeRange[
            this.result[this.result.length - 1]
          ].endTime
        this.rangeNum = this.result.length
        let arr = []
        if (this.insiderList.length) {
          this.insiderList.forEach((info) => arr.push(info.id))
          if (this.replaceStaffChecked && this.otherStaffData.length) {
            arr.push(this.otherStaffData[0].id)
          }
          this.checkRepeatt(arr.join(','))
        } else this.ifRepeat = false
        this.showStatus = false
      } else {
        Toast.fail(this.$t('预约时间段之间需连续'))
      }
    },
    async confirmMeeting() {
      if (!this.meetingTheme) {
        return Toast.fail(this.$t('请填写会议主题'))
      }
      if (this.meetingTheme.length > 50) {
        Toast.fail(this.$t('会议主题不能超过50字'))
        return
      }
      if (this.replaceStaffChecked && this.otherStaffData.length == 0) {
        Toast.fail(this.$t('请选择邀约人'))
        return
      }

      let meetingPeopleId = this.insiderList
        .map((item) => item.id)
        .filter((item) => !!item)
      meetingPeopleId.push(
        !this.replaceStaffChecked ? this.user.id : this.otherStaffData[0].id
      )
      meetingPeopleId = [...new Set(meetingPeopleId)]
      if (!meetingPeopleId || !meetingPeopleId.length) {
        Toast.fail(this.$t('请选择参会人'))
        return
      }

      let peopleId = []
      this.insiderList.forEach((item) => {
        if (item.departmentId.includes(',')) {
          let departmentList = item.departmentId.split(',')
          departmentList.forEach((departmentId) =>
            peopleId.push(item.id + '-' + departmentId)
          )
        } else {
          peopleId.push(item.id + '-' + item.departmentId)
        }
      })
      let appointmentEndTime = this.parameterDate + ' ' + this.endTime + ':00'
      let appointmentStartTime =
        this.parameterDate + ' ' + this.startTime + ':00'
      if (
        dayjs(appointmentEndTime).valueOf() -
        dayjs(appointmentStartTime).valueOf() >
        this.scheduledMaxTime * 60 * 60 * 1000
      ) {
        let maxTime = 0
        if (this.scheduledMaxTime >= 1) {
          maxTime = this.scheduledMaxTime + ' ' + this.$t('小时')
        } else {
          maxTime = this.scheduledMaxTime * 60 + ' ' + this.$t('分钟')
        }
        Toast.fail(
          this.$t('超过最大预约时间段:{maxTime}', { maxTime: maxTime })
        )
        return
      }
      this.isConfirm = true
      let data = {
        appointmentStartTime,
        appointmentEndTime,
        developerId: this.user.companyId,
        appointmentStaff: !this.replaceStaffChecked
          ? this.user.id
          : this.otherStaffData[0].id,
        sensitivity: this.encryption ? 'PRIVATE' : 'NORMAL',
        isVideoconferencing: this.isShowVideo ? 1 : 0,
        replaceAppointmentStaff: this.replaceStaffChecked
          ? this.user.id
          : undefined,
        meetingRecord: this.meetingContent,
        appointmentTopic: this.meetingTheme,
        meetingPeopleId: meetingPeopleId.join(),
        remindTime: this.preMeetingReminderTime,
        repeatType: 'single',
        peopleId: peopleId.join(','),
        relationMeetingId: this.relationMeeting.id,
        summaryPeopleId: this.summaryPeopleId,
        signBeforeMinute: this.devicesAIO?.signBeforeMinute || 10,
        signAfterMinute: this.devicesAIO?.signAfterMinute || 10,
        noSignReleaseTime: this.devicesAIO?.noSignReleaseTime || 10,
        preMeetingReminderTime: this.preMeetingReminderTime,
        meetingStaffMobile: this.meetingStaffMobile
          ? this.meetingStaffMobile
          : undefined,
        meetingLevel: this.meetingLevel ? this.meetingLevel : 0,
        openMeetingService:
          this.openMeetingService !== undefined &&
            this.openMeetingService !== null
            ? this.openMeetingService
              ? this.openMeetingService
              : false
            : undefined,
        precessDepartmentId: this.precessDepartmentId
          ? this.precessDepartmentId
          : undefined,
        meetingManger: this.meetingManger ? this.meetingManger : undefined,
      }
      try {
        if (this.ifOnline) {
          await appointmentOnline(data)
        } else if (!this.isReviewed) {
          await bookAppointment({
            ...data,
            multiMeetingRoomIds: this.meetingRoomId,
            otherPeopleRecord:
              this.outsiderList && this.outsiderList.length > 0
                ? JSON.stringify(this.outsiderList)
                : '',
          })
        } else {
          data.meetingRoomId = this.meetingRoomId[0]
          data.processConfigId = this.processConfigId
          await addTodo({
            ...data,
            // multiMeetingRoomIds: this.meetingRoomId,
            otherPeopleRecord:
              this.outsiderList && this.outsiderList.length > 0
                ? JSON.stringify(this.outsiderList)
                : '',
          })
        }
        Toast(
          this.isReviewed ? this.$t('会议申请成功') : this.$t('会议预约成功')
        )
        this.$router.push('meeting')
      } catch (error) {
        Toast.fail(error.response.data)
        if (!this.ifOnline) {
          this.getAppointmentList(
            this.user.companyId,
            this.parameterDate,
            this.meetingRoomId[0]
          )
        }
      } finally {
        this.isConfirm = false
      }
    },
    confirmOutsider() {
      if (this.showMobile == 2 && !this.emailTest()) {
        Toast.fail(this.$t('邮箱输入错误'))
        this.outsiderName = ''
        this.visitorMobile = ''
        this.outsiderEmail = ''
        return
      }
      if (this.showMobile == 1 && !this.mobileTest()) {
        Toast.fail(this.$t('手机号输入错误'))
        this.outsiderName = ''
        this.visitorMobile = ''
        this.outsiderEmail = ''
        return
      }
      this.outsiderList.unshift({
        name: this.outsiderName,
        mobile: this.visitorMobile,
        email: this.outsiderEmail,
      })
      this.outsiderName = ''
      this.visitorMobile = ''
      this.outsiderEmail = ''
    },
    emailTest() {
      return /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(
        this.outsiderEmail
      )
    },
    mobileTest() {
      return /^1[3-9]\d{9}$/.test(this.meetingStaffMobile)
    },
    toInform() {
      this.showInsider = false
      this.showOtherStaff = false
      this.showRelation = false
    },
    clickTime(index) {
      if (this.result.length < 2) return
      if (!this.result.some((num) => num == index)) return
      let arr = [...this.result]
      arr.sort((a, b) => a - b)
      let addList = []
      let ifOccupied = false
      for (let i = arr[0]; i <= arr[arr.length - 1]; i++) {
        if (this.validMeetingTimeRange[i].status !== '#FFFFFF') {
          this.result = arr.filter((num) => num != index)
          ifOccupied = true
          Toast.fail(this.$t('预约时间段之间存在已被占用的时间段'))
          break
        }
        addList.push(i)
      }
      if (!ifOccupied) {
        this.result = addList
      }
    },
    async checkMeeting() {
      if (this.startTime == '') {
        Toast.fail(this.$t('请选择会议时间'))
        return
      }
      if (this.params.scheduledDateLimit != 'everyday') {
        const ifHoliday = await getHoliday(
          dayjs(this.isDate).format('YYYYMMDD')
        )
        console.log(ifHoliday)
        if (ifHoliday == 1) {
          Toast.fail(this.$t('节假日不能预约会议室'))
          return
        }
      }
      // if (this.isReviewed && !this.mobileTest()) {
      //   Toast.fail(this.$t('手机号输入错误'))
      //   return
      // }
      if (!this.ifRepeat) {
        let time = this.startTime + '-' + this.endTime
        let day = this.timeFormat(this.isDate)
        this.confirmText = `${day} ${time}`
      } else {
        this.confirmText = this.$t('部分邀约人参会时间存在重叠，是否继续邀约？')
      }
      this.showConfirm = true
    },
    timeFormat(date) {
      const now = dayjs()
      const target = dayjs(date)
      const dayDiff = target.diff(now.startOf('day'), 'day')
      if (dayDiff === 0) {
        return this.$t('今天')
      } else if (dayDiff === 1) {
        return this.$t('明天')
      } else if (dayDiff === 2) {
        return this.$t('后天')
      } else if (dayDiff < 7 && now.week() === target.week()) {
        return this.$t('本{slot1}', { slot1: target.format('dddd') })
      }
      return target.format(this.$t('M月DD日'))
    },
    formatDate(date) {
      let weekday = new Array(7)
      weekday[0] = this.$t('周日')
      weekday[1] = this.$t('周一')
      weekday[2] = this.$t('周二')
      weekday[3] = this.$t('周三')
      weekday[4] = this.$t('周四')
      weekday[5] = this.$t('周五')
      weekday[6] = this.$t('周六')

      return weekday[dayjs(date).day()]
    },
  },
  computed: {
    totalTime() {
      return this.rangeNum * this.timeUnit
    },

    validMeetingTimeRange() {
      return this.meetingStatusList
        ?.filter(
          (v) =>
            dayjs(this.parameterDate + v.endTime).isAfter(dayjs()) &&
            v.endTime !== '24:00'
        )
        .map((v) => ({
          ...v,
          conflict: this.selfSchedule?.some((s) =>
            dayjs(this.parameterDate + v.endTime).isBetween(
              dayjs(s.beginTime),
              dayjs(s.endTime),
              'minutes',
              '(]'
            )
          ),
          current: dayjs().isBetween(
            dayjs(this.parameterDate + v.startTime),
            dayjs(this.parameterDate + v.endTime),
            'minutes',
            '[]'
          ),
        }))
    },
  },
  watch: {
    meetingRoomName: {
      deep: true,
      handler: function () {
        this.getAppointmentList(
          this.user.companyId,
          this.parameterDate,
          this.meetingRoomId[0]
        )
      },
    },
    repeatList: {
      deep: true,
      handler: function () {
        if (this.repeatList.length) {
          if (this.displayStaffList.length) {
            let staffList = [...this.displayStaffList]
            let ifInStaff = false
            this.repeatList.forEach((repeatData) => {
              staffList.forEach((staff) => {
                if (staff.id == repeatData.userId) {
                  staff.repeat = true
                  ifInStaff = true
                }
              })
            })
            ifInStaff && (this.displayStaffList = [...staffList])
          }
        } else {
          let staffList = [...this.displayStaffList]
          staffList.forEach((staff) => {
            staff.repeat = false
          })
          this.displayStaffList = [...staffList]
          let list = [...this.displayDepartmentList]
          list.forEach((item) => (item.repeat = false))
          this.displayDepartmentList = [...list]
        }

        if (this.displayDepartmentList.length) {
          let list = [...this.displayDepartmentList]
          let ifInList = false
          this.repeatList.forEach((repeatData) => {
            list.forEach((item) => {
              item?.staffs.forEach((staff) => {
                if (staff.staffId == repeatData.userId) {
                  item.repeat = true
                  ifInList = true
                }
              })
            })
          })
          ifInList && (this.displayDepartmentList = [...list])
        }
      },
    },
    encryption: {
      deep: true,
      handler: function (newVal) {
        this.meetingTheme = this.meetingTheme
          ? this.meetingTheme
          : newVal
            ? this.$t('专题会议')
            : ''
      },
    },
  },

  mounted() {
    this.params = this.$route.params
    console.log('this.params', this.params)
    if (!this.params || Object.keys(this.params).length === 0) {
      this.params = JSON.parse(
        localStorage.getItem('meetingInformParams') || '{}'
      )
    }

    this.isVideoconferencing = localStorage.getItem('isVideoconferencing')
    this.user = JSON.parse(localStorage.getItem('user'))
    this.params.meetingRoomName &&
      (this.meetingRoomName = this.params.meetingRoomName)
    this.params.meetingRoomId &&
      (this.meetingRoomId = [this.params.meetingRoomId])
    this.params.ifOnline && (this.ifOnline = this.params.ifOnline)
    this.startTime = this.params.startTime
    this.endTime = this.params.endTime
    this.date = this.params.date
    this.processConfigId = this.params.processConfigId
    this.rangeNum = this.params.length
    let tmpArr = [...this.params.result]
    this.isReviewed = this.params.isReviewed
      ? this.params.isReviewed
      : false
    this.isChoseDep = this.params.isChoseDep
      ? this.params.isChoseDep
      : false

    tmpArr.forEach((v) => {
      this.result.push(v - 0)
    })
    this.summaryResult = [0]
    this.summaryName = this.user.name
    this.summaryPeopleId = this.user.id + ''
    this.parameterDate = this.params.parameterDate
    this.defaultDate = new Date(this.params.parameterDate)
    this.nowDate = this.params.nowDate
    this.timeUnit = this.params.timeUnit
    this.scheduledMaxTime = this.params.scheduledMaxTime
    this.getUsers(this.user.companyId)
    this.isDate = new Date(this.params.parameterDate)
    this.getMeetingTimeRange(this.user.companyId)
    this.getMeetingRoomInformation(this.user.companyId)
    this.checkRepeatt(this.user.id)
    this.getALLInfo(
      this.params.meetingRoomId,
      this.user.id,
      this.isChoseDep,
      this.params.ifOnline
    )
    if (!this.ifOnline) {
      this.getAppointmentList(
        this.user.companyId,
        this.parameterDate,
        this.meetingRoomId[0]
      )
    }
    if (window.injectData && window.injectData.source == 'NewWorkApp') {
      this.sourceIsH5 = false
    }

    if (['1', '2', '3'].includes(this.isVideoconferencing) && this.ifOnline) {
      this.isShowVideo = true
    }
  },
}
</script>
<style lang="less" scoped>
.inform {
  min-height: 100%;
  background: #ffffff;
  padding-top: 1px;
  padding-bottom: 32px;
}

.metting-association {
  height: 80px;
  border-bottom: 1px solid #ececec;
  padding: 18px 16px 9px 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .metting-association-right {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 24px;
    margin-bottom: 5px;

    .metting-association-title {
      display: flex;
      align-items: flex-end;

      .metting-association-titel-big {
        font-weight: 600;
        font-size: 20px;
        color: #202020;
        margin-right: 7px;
      }

      .metting-association-titel-small {
        font-size: 12px;
        color: #aaaaab;
        margin-right: 7px;
        margin-bottom: 1px;
      }
    }

    img {
      height: 16px;
    }
  }

  .metting-association-name {
    font-size: 16px;
    color: #009cff;
    line-height: 24px;
    width: 190px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }
}

.metting-theme {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 13px 16px;
  border-bottom: 1px solid #ececec;

  .metting-theme-title {
    display: flex;
    align-items: center;
    margin-bottom: 6px;
    line-height: 24px;

    .metting-theme-icon {
      color: #ff3b30;
      font-size: 20px;
      font-weight: 600;
    }

    .metting-theme-name {
      font-weight: 600;
      font-size: 20px;
      color: #202020;
    }
  }

  /deep/.van-cell {
    padding: 0;
  }

  /deep/.van-field__control {
    font-size: 16px;
    color: #333333;
  }
}

.theme {
  margin-top: 12px;
  font-size: 17px;
}

.area {
  height: 56px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ececec;

  .location {
    height: 20px;
  }

  .areaName {
    padding-left: 8px;
    flex: 1;
  }

  .areaText {
    font-size: 14px;
    color: #aaaaab;
    padding-left: 8px;
    padding-right: 4px;
  }

  .pullMore {
    height: 16px;
  }
}

.areaMeeting {
  min-height: 56px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ececec;

  .location {
    height: 20px;
  }

  .areaName {
    padding-left: 8px;
    line-height: 24px;
    flex: 1;
  }

  .areaText {
    font-size: 14px;
    color: #aaaaab;
    padding-left: 8px;
    padding-right: 4px;
  }

  .pullMore {
    height: 16px;
  }
}

.van-cell {
  display: flex;
  align-items: center;
}

.informTime {
  margin-top: 12px;
  height: 116px;
  background: #fefffe;
  padding: 0px 16px;

  .informTime-top {
    display: flex;
    align-items: center;
    height: 69px;
    border-bottom: 1px solid #ededed;
    justify-content: space-between;
    font-size: 14px;

    .date-box {
      width: 92px;
      line-height: 24px;
    }

    img {
      height: 45px;
    }

    .totalTime {
      height: 100%;
      width: 80px;
      padding-left: 14px;
      display: flex;
      align-items: center;
      border-left: 1px solid #ededed;
      text-align: center;

      .allTime {
        color: #009bff;
      }
    }
  }

  .informTime-bottom {
    display: flex;
    align-items: center;
    height: 47px;
    border-bottom: 1px solid #ececec;

    img {
      height: 20px;
      margin-right: 8px;
    }
  }
}

.content {
  padding: 14px 16px;
  font-size: 16px;
  border-bottom: 1px solid #ececec;

  .content-top {
    font-weight: 600;
    font-size: 20px;
    color: #202020;
    // margin-bottom: 8px;
  }

  /deep/.van-cell {
    padding-left: 0;
    padding-right: 0;
  }
}

.replaceStaffBox {
  margin-bottom: 12px;
  margin-top: 12px;
  border-bottom: 1px solid #ececec;

  .replaceStaffBox-top {
    padding: 0px 16px;
    height: 45px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .replaceStaffBox-text {
      flex: 1;
      font-weight: 600;
      font-size: 20px;
      color: #202020;
    }

    .replaceStaffBox-staff {
      color: #009bff;
      margin-right: 8px;
    }

    img.pep {
      height: 20px;
      width: 20px;
    }

    img {
      height: 16px;
      width: 16px;
    }
  }

  .replaceStaffBox-bottom {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 42px;
    padding: 0 23px 0 16px;

    .replaceStaffBox-bottom-text {
      font-size: 16px;
      font-weight: 400;
      color: #999999;
      line-height: 24px;
    }
  }
}

.encryption {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 42px;
  padding: 0 23px 0 16px;
  border-bottom: 1px solid #ececec;

  .encryption-text {
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    line-height: 24px;
  }
}

.confereeBox {
  // margin-bottom: 12px;
  // margin-top: 12px;
  border-bottom: 1px solid #ececec;

  .confereeBox-top {
    padding: 17px 16px;
    // height: 56px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .text {
      flex: 1;
      font-weight: 600;
      font-size: 20px;
      color: #202020;
    }

    img {
      height: 20px;
    }
  }

  .confereeBox-bottom {
    padding: 0 16px;
    display: flex;
    flex-wrap: wrap;
    min-height: 100px;
    overflow: auto;
    background: #fefffe;
  }

  .outsiderWrap {
    min-height: 100px;
    overflow: auto;
    background: #ffffff;
  }

  .outsiderBox {
    margin: 10px 10px;
    height: 40px;
    display: flex;
    justify-content: space-between;
    background: #f4f4f4;

    .outsiderMsg {
      display: flex;
      font-size: 14px;
      align-items: center;
      background: #f4f4f4;
      border-radius: 2px;
      // border: 1px solid rgba(0, 0, 0, 0.15);
    }

    .outsiderName {
      height: 40px;
      width: 96px;
      line-height: 40px;
      text-align: center;
      border-right: 1px solid rgba(0, 0, 0, 0.1);
    }

    .outsiderEMail {
      padding-left: 23px;
      width: 221px;
    }

    .outsiderDel {
      display: flex;
      justify-content: center;
      align-items: center;
      background: #f4f4f4;
      width: 40px;

      img {
        height: 8px;
        width: 8px;
      }
    }
  }
}

.confrim-btn {
  width: 351px;
  margin: 32px auto 0px;
}

.timeListAll {
  padding-left: 16px;
  padding-top: 5px;
  font-size: 16px;
  height: 52px;
  width: 375px;
  line-height: 51px;
}

.timeList {
  position: relative;
  height: 424px;
  border-bottom: 1px solid #ebebeb;
  padding-left: 16px;
  overflow-y: auto;
  overflow-x: hidden;

  .timeListCard {
    height: 52px;
  }

  .van-checkbox__label {
    width: 330px;
  }

  .timeListRange {
    display: block;
    border-bottom: 1px solid #ebebeb;
    padding-left: 6px;
    font-size: 16px;
    height: 52px;
    width: 375px;
    line-height: 51px;

    .extra {
      padding-left: 24px;
    }
  }
}

.timeListTitle {
  height: 56px;
  line-height: 56px;
  border-bottom: 1px solid #ebebeb;
  padding-left: 20px;
}

.metting-summary {
  height: 60px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ececec;

  .text {
    flex: 1;
    font-weight: 600;
    font-size: 20px;
    color: #202020;
  }

  .metting-summary-left {
    display: flex;
    align-items: center;

    .meeting-summary-name {
      color: #009bff;
      margin-right: 3px;
    }

    img {
      height: 20px;
      width: 20px;
    }
  }
}

.bookBox {
  height: 72px;
  background: #f7f7f7;
  padding: 6px 12px 0px;
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;

  .book-btn {
    height: 44px;
    background: #009bff;
  }
}

/deep/.van-cell::after {
  border: none;
}

/deep/.outsiderStyle {
  width: 296px;

  .outsider-title {
    font-size: 18px;
    line-height: 24px;
    font-weight: 400;
  }

  .van-cell::after {
    border: none;
  }

  .van-dialog__header {
    padding: 16px 0px 8px;
  }

  .van-field__label {
    width: unset;
    line-height: 36px;
    font-size: 14px;
  }

  .outsider-input {
    border: 1px solid rgba(0, 0, 0, 0.15);
    height: 36px;
    padding-left: 8px;
    width: 192px;
  }

  input::-webkit-input-placeholder {
    color: #cfcfcf;
  }

  input::-moz-placeholder {
    color: #cfcfcf;
  }

  input:-moz-placeholder {
    color: #cfcfcf;
  }

  input:-ms-input-placeholder {
    color: #cfcfcf;
  }
}

.hasBorder {
  .van-field__label {
    width: 25%;
    text-align: center;
  }

  .van-cell__value {
    border: 1px #dcdcdc solid !important;
    padding: 0 8px;
    width: 60%;
  }
}

.getMargin {
  margin-bottom: 8px;
}

.van-field__control {
  font-size: 16px;
}

.van-dialog {
  border-radius: 4px !important;
}

.content-bottom {
  font-size: 16px;
}

.repeat-box {
  margin-top: 12px;
  background: #fefffe;
  margin-bottom: 20px;

  .repeatBox-top {
    padding-top: 9px;
    height: 37px;
    border-bottom: 1px solid #ededed;
    padding-left: 16px;

    .repeat-text {
      font-size: 12px;
      color: #ff3b30;
      line-height: 16px;
    }
  }

  .repeat-info-wrap {
    padding-left: 16px;
    padding-right: 10px;

    .repeat-info {
      // display: flex;
      border-bottom: 1px solid #ededed;
      padding-top: 15px;
      padding-bottom: 16px;

      .repeat-name {
        width: 75px;
        font-size: 16px;
        color: #666666;
        line-height: 24px;
      }

      .repeat-content {
        font-size: 14px;
        color: #999999;
        line-height: 24px;

        >div {
          margin-top: 8px;
        }
      }
    }
  }
}

.confirm-title {
  margin-top: 16px;
  font-size: 18px;
  color: #333333;
  line-height: 24px;
}

.confirm-content {
  margin-top: 17px;
  margin-bottom: 39px;
  font-size: 14px;
  color: #666666;
  line-height: 24px;
  text-align: center;
}

.confirm-content-repeat {
  width: 196px;
  height: 48px;
  margin-top: 5px;
  margin-bottom: 27px;
  font-size: 14px;
  color: #666666;
  line-height: 24px;
  text-align: center;
}

.noSummary {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
}

.metting-phone {
  width: 100%;
  height: 60px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ececec;
}

.phoneLine {
  display: flex;
  align-items: center;
}

.phoneIcon {
  color: #ff3b30;
  font-size: 16px;
  font-weight: 600;

}

.phoneText {
  width: 70px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #1e2329;
}

.phone-input {
  border-width: 0;
}

.metting-level {
  height: 83px;
  border-bottom: 1px solid #ececec;
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

.metting-service {
  height: 60px;
  border-bottom: 1px solid #ececec;
  padding: 0 16px;
  display: flex;
  align-items: center;
}

.levelText {
  width: 95px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #1e2329;
  margin-bottom: 10px;
}

.serviceText {
  width: 80px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #1e2329;
  line-height: 20px;
}

.popupOk {
  width: 351px;
  height: 52px;
  background: #ffffff;
  border-radius: 12px;
  display: flex;
  // justify-content: center;
  align-items: center;
  // margin-bottom: 12px;
}

.okTextStyle {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #1e2329;
}

.dropdownImg {
  width: 20px;
  height: 20px;
  transform: rotate(270deg);
}
</style>
